import React, { FC } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import AmountField from '~/components/AmountField';
import { Amount } from '~/types';

interface AmoutRowProps {
  category: string;
  amount?: Amount;
  item?: any;
}

const AmoutRow: FC<AmoutRowProps> = (props) => {
  const { category, amount, item } = props;

  return (
    <TableRow>
      <TableCell>{category}</TableCell>
      <TableCell>
        {amount && <AmountField amount={amount} />}
        {item}
      </TableCell>
    </TableRow>
  );
};

export default AmoutRow;
